import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TPostGenerateOrderPaymentLinkRequest } from "./postGenerateOrderPaymentLink.schema";

export const postGenerateOrderPaymentLink = (axios: IAxiosInstance) => {
  return async (params: TPostGenerateOrderPaymentLinkRequest) => {
    const response = await axios.noRetry.post<IApiResponse<string>>(
      "/api/orders/payment-link",
      params
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
